import cookie from './cookie'

// 用户是否登录
export function isLogin() {
  return !!cookie('token')
}
